{
  "tabs": {
    "summaryOfImages": "Summary of images",
    "userAnalytics": "User Analytics",
    "graderScorecard": "Grader Scorecard",
    "mbGatewayMovement": "MB Gateway Movement",
    "beefAnalytics": "Beef Analytics",
    "ausMeatOmm": "AUS-MEAT OMM",
    "imageComparison": "Image Comparison",
    "wagyu": "Wagyu"
  },
  "wagyu": {
    "libraryTitle": "Wagyu Marbling Reference Library",
    "librarySubtitle": "A visual benchmark of rib eye marbling across the USDA scale, with AUS Marbling equivalents. Used for grader alignment, training and brand-positioning discussions.",
    "gridTitle": "Wagyu Rib Eye Reference Grid",
    "gridSubtitle": "{{perBucket}} samples per 25-pt USDA marbling bracket · {{brackets}} brackets · {{cells}} cells",
    "axisLabel": "USDA marbling score (25-pt brackets)",
    "gridShowing": "Showing brackets {{from}} – {{to}} of {{total}}",
    "gridScrollHintBefore": "Scroll",
    "gridScrollHintAfter": "for higher marbling",
    "prevBrackets": "Previous brackets",
    "nextBrackets": "Next brackets",
    "usda": "USDA Marbling",
    "ausMarbling": "AUS Marbling",
    "msa": "MSA",
    "barcode": "Barcode",
    "date": "Date & time",
    "usdaShort": "USDA",
    "ausShort": "AUS",
    "imageAlt": "Wagyu sample {{barcode}}",
    "selectedSample": "Selected sample",
    "bracket": "Bracket",
    "close": "Close"
  },
  "imageComparison": {
    "newImageComparison": "New Image Comparison",
    "reset": "Reset",
    "imagesForComparison": "Images for comparison",
    "compareAgainst": "Compare against {{stream}} images",
    "selectImagesCapture": "Select images captured by your team",
    "selectFromStream": "Select from {{stream}} graded images (Anonymised)",
    "clearAllFilters": "Clear all filters",
    "saveView": "Save a view",
    "save": "Save",
    "viewName": "View name",
    "enterViewName": "Enter a name for this view",
    "subTitle": "Sub title (Eg, specific breed, brand, location or grade)",
    "addDescription": "Add a description (optional)",
    "saveViewButton": "Save view",
    "compareAgainstUSDA": "Compare Against USDA Graded Images",
    "compareAgainstAUS": "Compare Against AUS Marble Graded Images",
    "createComparisons": "Create image comparisons and views",
    "chooseFilters": "Choose some filters above to get started",
    "noImagesFound": "No images found for selected filters",
    "adjustFilters": "Adjust filters or time period above",
    "view": "View",
    "filters": "Filters",
    "filtersCompared": "Filters compared",
    "created": "Created",
    "deleteView": "Delete view",
    "savedViews": "Saved Views",
    "savedViewsPlaceholder": "Saved views will be shown here",
    "filter": "Filter",
    "noImage": "No image",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "showAllTraits": "Show all traits"
  },
  "userAnalytics": {
    "avgCameraScoresPerDay": "Avg Camera Scores per day",
    "avgOverridesPerDay": "Avg Overrides per day",
    "avgOverrideUnderScoresPerDay": "Avg Override Under Scores per day",
    "avgOverrideOverScoresPerDay": "Avg Override Over Scores per day",
    "cameraUserSummary": "Camera User Summary",
    "cameraUser": "Camera User",
    "totalShifts": "Total Shifts",
    "shifts": "Shifts",
    "total": "total",
    "totalBarcodesScanned": "Total Barcodes Scanned",
    "barcodes": "Barcodes",
    "totalScanned": "total scanned",
    "avgOverride": "Avg Override",
    "avgUnderScore": "Avg Under Score",
    "avgOverScore": "Avg Over Score",
    "perShift": "per shift",
    "agreementRate": "Agreement Rate",
    "underScore": "Under Score",
    "overScore": "Over Score",
    "underScorePct": "Under Score %",
    "overScorePct": "Over Score %",
    "barcodesScanned": "Barcodes Scanned",
    "date": "Date",
    "scoreDifference": "Score Difference",
    "scoreDifferencePerDayTitle": "Score Difference per day ({{metric}})",
    "scoreDifferencePerDay": "Score Difference per day",
    "scoreDifferencePerDayDesc": "We're highlighting how many times a camera user over scores, under scores or agrees with the MEQ Camera grade. Significant fluctuations will impact costs and quality.",
    "scoreDifferencePerDaySubtitle": "Shows camera user over scores and under scores versus camera per day, zoom for detail.",
    "cameraUserAll": "Camera User - All",
    "overrideScoreAll": "Override score - All",
    "overrideHigherBy": "Override score higher by",
    "overrideLowerBy": "Override score lower by",
    "overrideAgrees": "Override score agrees with camera",
    "inOutOfGradings": "in {{n}} out of {{m}} gradings",
    "frequency": "Frequency",
    "scoreDifferenceDistribution": "Score Difference Distribution",
    "scoreDifferenceDistributionDesc": "Based on the timeframe selected at the top of the screen. We're highlighting the overall frequency of under scores, over scores and agreements by a grader with the MEQ Camera.",
    "scoreDifferenceDistributionSubtitle": "Shows amount of score difference to camera, zoom for detail.",
    "graderHigherBy": "Grader higher by {{n}}, {{frequency}} times",
    "graderLowerBy": "Grader lower by {{n}}, {{frequency}} times",
    "graderAgrees": "Grader agrees with camera, {{frequency}} times",
    "numberOfOverUnderScores": "Number of Over/Under Scores",
    "overScoreVsUnderScorePerDay": "Over Score vs Under Score per day",
    "overScoreVsUnderScorePerDayDesc": "Shows the daily over score and under score numbers per user.",
    "overScoreVsUnderScorePerDaySubtitle": "Shows daily over score and under score numbers of camera users.",
    "cameraUserOverScoreClick": "Camera User: {{name}} | Over Score Count: {{count}} | Click for more",
    "cameraUserUnderScoreClick": "Camera User: {{name}} | Under Score Count: {{count}} | Click for more",
    "imagesTitle": "{{metric}} Images",
    "imagesSubtitle": "{{date}} · {{frequency}} {{percentage}}",
    "gradingImagesTitle": "{{user}} Images",
    "gradingSelection": "Camera {{score}} → Grader {{override}}",
    "overrideScore": "Override score"
  },
  "beefAnalytics": {
    "probeRunningAvg": "Probe Running Avg",
    "cameraRunningAvg": "Camera Running Avg",
    "ausMarbling": "AUS Marbling",
    "avgDifferenceCameraProbe": "Avg Difference Camera-Probe",
    "precisionOfProbe": "Precision of Probe",
    "precisionOfProbeSubtitle": "% Camera Score >= Probe Score",
    "carcases": "Carcases",
    "numberOfDarkCutters": "Number of Dark Cutters",
    "volumeOfCarcases": "Volume of carcases with PH above 5.7",
    "totalCarcases": "Total Carcases: {{value}}",
    "phRange": "PH: {{start}} - {{end}} | Carcases: {{count}}",
    "eyeMuscleArea": "Eye Muscle Area (cm2)",
    "marblingVsEyeMuscleArea": "Marbling vs Eye Muscle Area (cm2)",
    "distributionOfCarcases": "Distribution of carcases",
    "camera": "Camera",
    "probe": "Probe",
    "eyeMuscleAreaMarbling": "Eye Muscle Area (cm2): {{x}} | AUS Marbling: {{y}}"
  },
  "summaryOfImages": {
    "captureDays": "Capture Days",
    "captureDate": "Date",
    "totalImages": "Total Images",
    "dcuLite": "DCU Lite",
    "averages": "Averages",
    "actions": "Actions",
    "viewDetails": "View details",
    "viewDetailsForDate": "View details for {{date}}",
    "viewImages": "View images",
    "viewGraders": "View graders",
    "gradersTitle": "Graders on {{date}}",
    "gradersEmpty": "No graders recorded for this day",
    "averagesTitle": "Averages for {{date}}",
    "downloadDay": "Download this day",
    "imagesGradedBy": "{{count}} images · Graded by {{graders}}",
    "imagesCount": "{{count}} images",
    "listOfImages": "List of images",
    "dayLine": "· {{date}} - {{images}} Images",
    "dayImagesFiltered": "{{label}} {{matched}}/{{total}}",
    "dayImagesFilteredMultiple": "Filtered to {{matched}}/{{total}}",
    "noValue": "—",
    "location": "Location",
    "downloadCsvRangeLabel": "Date range",
    "downloadCsvRangePlaceholder": "Select a date range",
    "downloadCsvMaxRangeError": "Select a range of {{max}} days or fewer",
    "downloadCsvButton": "Download CSV",
    "downloadCsvSuccess": "Your CSV download has started",
    "downloadCsvError": "Failed to download CSV. Please try again."
  },
  "imagesModal": {
    "close": "Close",
    "viewMode": "View mode",
    "modeTable": "List",
    "modeGrid": "Images",
    "filters": "Filters",
    "filterAll": "All",
    "filterGrader": "Grader",
    "filterUsdaGrade": "USDA Grade",
    "filterAusMarbling": "AUS Marbling",
    "filterMeatColor": "Meat Color",
    "filterFatColor": "Fat Color",
    "gradePrime": "Prime",
    "gradeChoice": "Choice",
    "gradeSelect": "Select",
    "gradeStandard": "Standard",
    "filterSex": "Sex",
    "filterMsaGrading": "MSA grading",
    "filterMsaOnly": "MSA",
    "filterNonMsaOnly": "Non-MSA",
    "filterDcuLite": "DCU Lite",
    "filterDcuLiteOnly": "DCU Lite",
    "filterStandardOnly": "Standard",
    "filterEmaMissedOnly": "EMA missed only",
    "filterBodyIdRange": "Body ID range",
    "filterBodyIdFrom": "Body ID from",
    "filterBodyIdTo": "Body ID to",
    "filterBodyIdInvalid": "\"To\" must be greater than or equal to \"from\"",
    "filterEmaMissing": "EMA missing",
    "filterBodyId": "Body ID",
    "filtersClear": "Clear filters",
    "sortBy": "Sort by",
    "sortByColumn": "Sort by: {{column}}",
    "sortNone": "Unsorted",
    "sortDirection": "Sort direction",
    "sortAscending": "Ascending",
    "sortDescending": "Descending",
    "noImages": "No images match these filters",
    "tileBody": "Body {{value}}",
    "imageDetails": "Image details",
    "imagePosition": "Image {{current}} of {{total}}",
    "previousImage": "Previous image",
    "nextImage": "Next image",
    "noValue": "—",
    "drillFilterRemove": "Show all images"
  },
  "ausMeatOmm": {
    "cameraUserSummary": "Camera User Summary",
    "date": "Date",
    "status": "Status",
    "carcaseCount": "Carcase Count",
    "notGenerated": "Not Generated",
    "generated": "Generated",
    "sent": "Sent",
    "ommConfiguration": "OMM Configuration",
    "view": "View",
    "generate": "Generate",
    "download": "Download",
    "csv": "CSV",
    "send": "Send",
    "ommMessages": "OMM Messages",
    "ommFileGenerated": "OMM file generated.",
    "ommFileSent": "OMM file sent.",
    "failedToSendOmm": "Failed to send OMM file.",
    "ommDataNotFound": "OMM data not found",
    "noOmmFileToSend": "No OMM file available to send",
    "ommFileNotFound": "OMM file not found.",
    "savedOmmConfig": "Successfully saved OMM configuration.",
    "failedToSaveOmmConfig": "Failed to save OMM configuration.",
    "apiKey": "API Key",
    "establishmentNumber": "Establishment Number",
    "chainNumber": "Chain Number",
    "cancel": "Cancel",
    "save": "Save"
  },
  "graderScorecard": {
    "title": "Grader Scorecard",
    "description": "Daily snapshot of grader agreement with the camera, one column per grader. Every value is a % of that grader's scanned bodies — click a cell to see the underlying counts.",
    "metric": "Metric",
    "order": "Order",
    "agreementPct": "% Agreement",
    "overPct": "% Over",
    "underPct": "% Under",
    "orderAz": "A–Z",
    "orderMostAgreement": "Most → Least Agreement",
    "distribution": "Distribution",
    "distributionHint": "Split % Over / % Under by override distance (out by 1, out by 2, 3+)",
    "distributionAgreementHint": "Switch to % Over or % Under to split by override distance",
    "distributionFootnote": "Distribution uses graded bodies (with a camera score) as the denominator, so values can differ slightly from the plain view",
    "dateRange": "Date Range",
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "date": "Date",
    "shiftsAndScans": "{{shifts}} shifts · {{scans}} scans",
    "periodAvg": "{{days}}-day Avg",
    "good": "Good",
    "warning": "Warning",
    "bad": "Bad",
    "legendFootnote": "Values are % of the grader's scanned bodies · click a cell for counts",
    "noData": "No grading data for the selected period.",
    "decisionMixTitle": "{{days}}-Day Decision Mix",
    "decisionMixDescription": "Each grader's selected period split by override distance, ranked most → least agreement. Colour is the distance, position is the direction — under scored to the left, over scored to the right.",
    "decisionMixAgreement": "Agreement",
    "decisionMixUnderBy2Plus": "Under by 2 or more",
    "decisionMixUnderBy1": "Under by 1",
    "decisionMixOverBy1": "Over by 1",
    "decisionMixOverBy2Plus": "Over by 2 or more",
    "decisionMixScans": "{{scans}} scans",
    "dayBreakdownDescription": "{{total}} grading decisions against the MEQ Camera on {{trait}}. Percentages are the share of those {{total}} decisions.",
    "dayBreakdownDecisions": "Decisions",
    "dayBreakdownAgreement": "Agreement",
    "dayBreakdownOver": "Over",
    "dayBreakdownUnder": "Under",
    "dayBreakdownBodies_one": "{{count}} body",
    "dayBreakdownBodies_other": "{{count}} bodies",
    "dayBreakdownDrillHint": "Select a tile or row to view its images.",
    "dayBreakdownRowLabel": "Out by {{label}}",
    "dayBreakdownViewImages": "View images: {{label}}",
    "dayBreakdownOverTitle": "Over scored — grader above camera",
    "dayBreakdownUnderTitle": "Under scored — grader below camera"
  },
  "mbGatewayMovement": {
    "title": "MB Gateway Movement",
    "titleInfo": "How grader overrides move carcases across the brand gateways set in Gateway pricing, and what that movement is worth per head.",
    "pricingButton": "Gateway pricing",
    "loadError": "Couldn't load the saved gateway pricing.",
    "pricing": {
      "title": "Gateway pricing",
      "info": "Give each MB gateway a $ / head value. A gateway priced above 0 opens a brand band; a carcase belongs to the band of the nearest priced gateway at or below its grade. Moving a carcase across a gateway is worth that gateway's value. MB 0 is the floor and has no gateway.",
      "columnGateway": "Gateway",
      "columnProgram": "Brand / program",
      "columnValuePerHead": "$ / head",
      "columnBoundary": "Brand boundary",
      "gatewayLabel": "MB {{grade}}+",
      "opensBand": "✓ opens a band",
      "programPlaceholder": "Program name",
      "programLabel": "Brand / program for MB {{grade}}+",
      "priceLabel": "$ / head for MB {{grade}}+",
      "priceErrors": {
        "notANumber": "Enter a number",
        "negative": "Can't be negative",
        "tooLarge": "At most $100,000",
        "decimals": "At most 2 decimal places"
      },
      "bandRange": "MB {{start}}–{{end}}",
      "bandSingle": "MB {{start}}",
      "unnamedBand": "Unnamed brand",
      "belowFirstBand": "no brand",
      "bandsLabel": "Bands",
      "noBands": "No bands defined — $ figures will be hidden",
      "thresholdBefore": "the biggest movements — at least",
      "thresholdAfter": "% of value moved",
      "thresholdInfo": "A movement is starred when its $ impact is at least this share of all value moved in the selected range, so the movements that matter most stand out regardless of how many bodies they involve.",
      "thresholdLabel": "Biggest movements threshold (%)",
      "thresholdErrors": {
        "notANumber": "Enter a number",
        "outOfRange": "More than 0, at most 100"
      },
      "reset": "Reset",
      "cancel": "Cancel",
      "apply": "Apply",
      "saveError": "Couldn't save gateway pricing. {{message}}"
    },
    "siteLabel": "Site",
    "matrixLoadError": "Couldn't load grading movement for this range.",
    "kpis": {
      "bodiesGraded": "Bodies graded",
      "bodiesGradedSub": "{{share}} agreed with the camera",
      "moved": "Moved an MB grade",
      "movedSub": "{{share}} of bodies",
      "changedBand": "Changed brand band",
      "changedBandSub": "{{share}} of bodies · {{movementShare}} of all movement",
      "noBands": "Set gateway pricing to see brand bands",
      "netImpact": "Net $ impact",
      "netImpactSub": "{{gross}} gross value moved",
      "noPricing": "Set gateway pricing to see $",
      "trendVsLast": "vs last period",
      "trendPts": "{{value}} pts",
      "trendFlat": "No change",
      "trendUp": "Up",
      "trendDown": "Down"
    },
    "ungradedNote_one": "{{bodies}} body had no camera grade and is not in the matrix.",
    "ungradedNote_other": "{{bodies}} bodies had no camera grade and are not in the matrix.",
    "show": "Show",
    "modes": {
      "bodies": "Bodies",
      "pctOfCameraGrade": "% of camera grade",
      "pctOfAll": "% of all bodies",
      "value": "$ impact"
    },
    "valueModeDisabled": "Set gateway pricing to see $ impact",
    "matrix": {
      "finalGradeHeader": "Final grade after grader override",
      "cameraGradeHeader": "Camera grade",
      "grade": "MB {{grade}}",
      "rowSub": "{{bodies}} bodies · {{share}}",
      "cameraTotal": "Camera total",
      "finalTotal": "Final grade total",
      "boundaryColumn": "MB {{grade}}+ is a brand boundary",
      "cellLabel": "Camera MB {{camera}}, final MB {{final}}: {{value}}",
      "material": "Material movement"
    },
    "legend": {
      "agreed": "Agreed",
      "up": "Grader up",
      "down": "Grader down",
      "boundary": "Crosses a brand boundary",
      "material": "Material",
      "allGraders": "all graders"
    },
    "empty": {
      "title": "No graded bodies in this range",
      "body": "Try a longer date range or another grader."
    },
    "detail": {
      "title": "Camera MB {{camera}} → final MB {{final}}",
      "agreedTitle": "Camera and grader agreed on MB {{grade}}",
      "agreedSummary_one": "{{bodies}} carcase the camera graded MB {{grade}} was finalised MB {{grade}} — the grader agreed with the camera.",
      "agreedSummary_other": "{{bodies}} carcases the camera graded MB {{grade}} were finalised MB {{grade}} — the grader agreed with the camera.",
      "moveSummary_one": "{{bodies}} carcase the camera graded MB {{camera}} was finalised MB {{final}} by the grader — {{movement}}.",
      "moveSummary_other": "{{bodies}} carcases the camera graded MB {{camera}} were finalised MB {{final}} by the grader — {{movement}}.",
      "up_one": "up one grade",
      "up_other": "up {{count}} grades",
      "down_one": "down one grade",
      "down_other": "down {{count}} grades",
      "bodies": "Bodies",
      "shareOfCameraGrade": "Share of camera MB {{grade}}",
      "shareValue": "{{bodies}} of {{total}} = {{share}}",
      "impact": "$ impact",
      "impactValue": "{{total}} ({{bodies}} × {{perHead}} / head)",
      "boundariesHeading": "Brand boundaries crossed",
      "crosses": "Crosses MB {{grade}}+ ({{program}}, {{perHead}} / head)",
      "crossesUnnamed": "Crosses MB {{grade}}+ ({{perHead}} / head)",
      "sameBand": "Both grades sit in {{program}}, so nothing moved on price.",
      "sameBandUnnamed": "Both grades sit in the MB {{start}}+ band, so nothing moved on price.",
      "sameBelowFirst": "Both grades sit below the first brand gateway, so nothing moved on price.",
      "noPricing": "Gateway pricing isn't set for this site, so $ impact isn't shown.",
      "material": "Material movement — at least {{threshold}}% of all value moved in this range."
    }
  },
  "columnResolution": {
    "columns": {
      "preset": "Camera preset",
      "config": "Camera config"
    },
    "source": {
      "declared": "Declared by the settings document {{org}} / {{location}}",
      "country": "Country default for {{country}}. Nobody chose this; it applies because the location has no preset of its own.",
      "legacy": "No preset. Columns come from the legacy traits and blacklist on the settings document."
    },
    "legacyChip": "Legacy",
    "flags": {
      "deviation": "Deviation",
      "unknown": "Unknown",
      "deadLegacy": "Dead config"
    },
    "flagHints": {
      "deviation": "The settings document adds, omits, reorders or re-sorts columns on top of the preset.",
      "unknown": "Config names columns the registry has never heard of, so they are dropped: {{values}}",
      "deadLegacy": "The document carries legacy traits or a blacklist that a preset supersedes. They do nothing."
    },
    "title": "Camera columns",
    "spine": "Capture-day metrics",
    "columnsList": "Columns",
    "popover": "Day averages",
    "defaultSort": "Default sort",
    "exportOmit": "Withheld from export",
    "unknownValues": "Unknown values",
    "deadLegacy": "Superseded legacy config",
    "deviation": "Deviation as stored",
    "ascending": "ascending",
    "descending": "descending",
    "none": "none"
  }
}
